import axios from 'axios';

// initial state
const state = {

  // record form
  recordForm: {},
  showRecordForm: false,

  // data
  records: [],
}

// mutations
const mutations = {

  SET_RECORDS(state, records) {
    state.records = records;
  },

  SHOW_RECORD_FORM(state) {
    state.showRecordForm = true;
  },

  HIDE_RECORD_FORM(state) {
    state.showRecordForm = false;
  },

  DELETE_RECORD(state, { recordId, recordType }) {
    state.records.forEach((item, index) => {
      if (
        item.id == recordId &&
        typeof (item.sub_section_id) == (recordType == 'article' ? 'number' : 'undefined')
      ) {
        state.records.splice(index, 1);
      }
    });
  },
}

// actions
const actions = {

  fetchRecords({ commit }) {
    return axios.get('/admin/content/banner-slides')
      .then((response) => {
        commit('SET_RECORDS', response.data.slides);
      });
  },

  // =========================================================================

  setAsSlide({ }, { recordId, recordType }) {
    return axios.post(`/admin/${recordType == 'article' ? 'articles' : 'news'}/${recordId}/slide`);
  },

  // =========================================================================

  removeSlide({ commit }, { recordId, recordType }) {
    return axios.delete(`/admin/${recordType == 'article' ? 'articles' : 'news'}/${recordId}/slide`)
      .then(() => {
        commit('DELETE_RECORD', { recordId, recordType });
      });
  }
}

export default {
  namespaced: true,
  name: 'carousel',
  state,
  actions,
  mutations
}
